import { createSlice ,current} from '@reduxjs/toolkit';

export const cardSlice = createSlice({
    name: 'card',
    initialState: {
        items: [],
        couponCode: "",
        couponDiscount: 0,
        subTotal: 0,
        grandTotal: 0,
        totalSavings: 0,
        shippingCharges: 0,
    },

    reducers: {
     
        addItem: (state, action) => {
        
            const existingItemIndex = state.items.findIndex(item => item.product_id === action.payload.product_id);
          
            if (existingItemIndex !== -1) {
                state.items[existingItemIndex] = {
                    ...state.items[existingItemIndex],
                    quantity: state.items[existingItemIndex].quantity + 1
                };
            }  else {

                let object ={
                    ...action.payload,
                    quantity : 1
                }
                state.items.push(object);
            }
        },

        removeItem: (state, action) => {
            const existingItemIndex = current(state.items).findIndex(item => item.product_id === action.payload.product_id);
            if (existingItemIndex !== -1) {
                if (state.items[existingItemIndex].quantity > 1) {
                    state.items[existingItemIndex].quantity -= 1;
                } else {
                    state.items.splice(existingItemIndex, 1);
                }
            }
        },

        removeOneCompleteItem:(state, action)=>{
            const updatedItems = state.items.filter(item => item.product_id !== action.payload.product_id);
            return {
                ...state,
                items: updatedItems
            };
        },

        allRemoveItem:(state, action) => {
            state.items = []
        },

        AddAllItem:(state, action) => {
            state.items = action.payload
        },

        setCouponData: (state, action) => {
            const { couponCode, couponDiscount,subTotal, grandTotal, totalSavings, shippingCharges } = action.payload;
            state.couponCode = couponCode;
            state.couponDiscount = couponDiscount;
            state.subTotal = subTotal;
            state.grandTotal = grandTotal;
            state.totalSavings = totalSavings;
            state.shippingCharges = shippingCharges;
        },

        clearCouponData: (state) => {
            state.couponCode = "";
            state.couponDiscount = 0;
            state.subTotal = 0;
            state.grandTotal = 0;
            state.totalSavings = 0;
            state.shippingCharges = 0;
        }
    },
});

export const { addItem, removeItem ,allRemoveItem,removeOneCompleteItem,AddAllItem,setCouponData,clearCouponData} = cardSlice.actions;

export default cardSlice.reducer;
